// Notifications sortantes : webhook HTTP optionnel (n8n → Telegram, e-mail, etc.).
// Envoi « fire and forget » depuis le navigateur, uniquement sur événements.
let webhookUrl = '';
let cabinetName = '';

export class NotifyService {
  static configure({ url = '', cabinet = '' } = {}) {
    webhookUrl = (url || '').trim();
    cabinetName = cabinet || '';
  }

  static isConfigured() {
    return /^https?:\/\//.test(webhookUrl);
  }

  // event: 'statut' | 'avance' | 'depense' | 'retard' | 'test'
  static send(event, payload = {}) {
    if (!NotifyService.isConfigured()) return Promise.resolve(false);
    const body = JSON.stringify({
      event,
      cabinet: cabinetName,
      sentAt: new Date().toISOString(),
      ...payload
    });
    try {
      return fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true
      }).then(() => true).catch((e) => {
        console.warn('Webhook non joignable:', e.message);
        return false;
      });
    } catch (e) {
      return Promise.resolve(false);
    }
  }
}
